import React, { useState, useEffect } from 'react';
import Classes from './ViewReport.module.css';
import Logo from '../../../../LocalComp/Logo/Logo';
import Hero1 from './Comp/Hero1';
import RecordTable from '../../Dashboard/Comp/RecordTable/RecordTable';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import backend from '../../../../../../api';

export default function ViewReport() {
  const { id } = useParams();
  const { user } = useSelector((state) => state.auth);
  const userId = user?._id;

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await backend.get(`/user-information?userId=${userId}`);
        const allReports = response.data;
        const [month, year] = id.split('-');
        const filteredReports = allReports.filter((report) => {
          const reportDate = new Date(report.createdAt);
          return (
            reportDate.toLocaleString('default', { month: 'long' }) === month &&
            reportDate.getFullYear() === parseInt(year)
          );
        });
        setReports(filteredReports);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching reports:', error);
        setLoading(false);
      }
    };
    fetchReports();
  }, [id, userId]);

  const handleStatusUpdate = async (reportId, newStatus) => {
    try {
      await backend.put(`/user-information/${reportId}`, { analyzingstatus: newStatus });
      setReports((prevReports) =>
        prevReports.map((report) =>
          report._id === reportId ? { ...report, analyzingstatus: newStatus } : report
        )
      );
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const handleDelete = async (reportId) => {
    if (window.confirm('Are you sure you want to delete this report?')) {
      try {
        await backend.delete(`/user-information/${reportId}`);
        setReports((prevReports) => prevReports.filter((report) => report._id !== reportId));
      } catch (error) {
        console.error('Error deleting report:', error);
      }
    }
  };

  if (loading) return <h5 className='lightText' style={{ margin: '30px 0 0 40px' }} >Loading...</h5>;

  if (reports.length === 0) return <h5 className='lightText' style={{ margin: '30px 0 0 40px' }} >No reports found for this month.</h5>;

  const firstReport = reports[0];
  const lastReport = reports[reports.length - 1];
  const title = `Exposure Report: ${id.replace('-', ' ')}`;
  const dateRange = `${new Date(firstReport.createdAt).toLocaleDateString()} - ${new Date(lastReport.updatedAt).toLocaleDateString()}`;
// _id will be copied into every exposure under a new key, e.g. reportId
const allExposures = reports.flatMap(({ _id, exposures = [] }) =>
  exposures.map((exp) => ({ ...exp, reportId: _id }))
);


  return (
    <div className={Classes.hero}>
      <div className={Classes.wrapper}>
        <div className={Classes.header}>
          <div>
            <Logo alwaysShowText={true} />
          </div>
          <div className={Classes.headerRight}>
            <h3>{title}</h3>
            <h5>{dateRange}</h5>
          </div>
        </div>
{/* 
        <div className={Classes.reportsList}>
          <h3>Reports for {id.replace('-', ' ')}</h3>
          {reports.map((report) => (
            <div key={report._id} className={Classes.reportItem}>
              <h4>Report ID: {report._id}</h4>
              <p>Status: {report.analyzingstatus}</p>
              <select
                value={report.analyzingstatus}
                onChange={(e) => handleStatusUpdate(report._id, e.target.value)}
              >
                <option value="pending">Pending</option>
                <option value="processing">Processing</option>
                <option value="completed">Completed</option>
                <option value="failed">Failed</option>
              </select>
              <button onClick={() => handleDelete(report._id)}>Delete</button>
            </div>
          ))}
        </div> */}

        <Hero1 exposures={allExposures} />

        <RecordTable
          report={reports}
          exposures={allExposures}
          userId={userId}
        />

        <div className={Classes.footer}>
          <h5>Report generated by PrivacyBot</h5>
        </div>
      </div>
    </div>
  );
}